import React, { useState } from "react";
import { Button, Row, Col, Divider } from "antd";
import "../../utils/recapNewMerchant.css"


const RecapNewMerchant = ({
  merchantDocs,
  createdBusiness,
  onSubmitFinal,
  isSubmitting,
  error,
  onCancelAll,
}) => {
  const [loading, setLoading] = useState(false);

  return (
    <div className="newMerchant-recap-container" style={{ position: "relative" }}>
      <h2 className="newMerchant-recap-title">Récapitulatif</h2>
      
      {error && <div className="alert alert-danger">{error}</div>}
      <Row gutter={[16, 16]}>
        <Col xs={24} md={24} lg={12}>
          <div className="newMerchant-recap-card">
            <h3 className="newMerchant-recap-card-title">
              📄 Mes documents KYC
            </h3>
            <Divider />

            <p>
              <strong>Type :</strong> {merchantDocs?.type || "-"}
            </p>

            <p>
              <strong> {merchantDocs?.type === "PASSPORT" ? "Document" : "Recto CNU"}</strong>{" "}
              {merchantDocs?.merchantRecto ? "✔ Uploadé" : "Non uploadé"}
            </p>

            {merchantDocs?.type === "CNI" && (
              <p>
                <strong>Verso :</strong>{" "}
                {merchantDocs?.merchantVerso ? "✔ Uploadé" : "Non uploadé"}
              </p>
            )}
          </div>
        </Col>

        <Col xs={24} md={24} lg={12}>
          <div className="newMerchant-recap-card">
            <h3 className="newMerchant-recap-card-title">
              🏢 Mon premier business
            </h3>
            <Divider />

            <p>
              <strong>Nom :</strong>{" "}
              {createdBusiness?.businessName || "-"}
            </p>

            <p>
              <strong>Pays :</strong>{" "}
              {createdBusiness?.country || "-"}
            </p>

          </div>
        </Col>
      </Row>

      <div className="newMerchant-recap-actions">
        <Button
          danger
          onClick={onCancelAll}
          loading={loading}
          className="newMerchant-btn-cancel"
        >
          Annuler
        </Button>

        <Button
          type="primary"
          onClick={onSubmitFinal}
          loading={isSubmitting}
          disabled={
            isSubmitting ||
            !createdBusiness ||
            !merchantDocs?.merchantRecto ||
            (merchantDocs?.type === "CNI" && !merchantDocs?.merchantVerso) ||
            !merchantDocs?.RIB ||
            !merchantDocs?.Domicile
          }
          className="newMerchant-btn-submit"
        >
          Soumettre
        </Button>
      </div>
    </div>
  );
};

export default RecapNewMerchant;